import { MediaFragment } from '@graphql/generated/graphql';
import getSrcSets from '@lib/image/utils';
import { getStrapiAssetUrl } from '@lib/strapi';

export const toImage = (
    file: MediaFragment | null | undefined,
    fileUrl: string | null | undefined,
    alt: string
) => ({
    src: file ? getStrapiAssetUrl(file) : fileUrl || '',
    alt: file ? file.alternativeText || alt : alt,
    srcSet: file ? getSrcSets(file.formats).regular ?? undefined : undefined,
});
